$(document).ready(function () {
    var prodid = $(".prodid").val();
    var bakilanurun = Vivense.cookie.get("skubak");
    var shwbak = Vivense.cookie.get("shwbak");

    if (!bakilanurun) {
        Vivense.cookie.set("skubak", prodid, 7 * 24); // 1 week
    } else {
        var bakilanarray = bakilanurun.split(',');
        if (bakilanarray.indexOf(prodid) == -1) {
            Vivense.cookie.set("skubak",  bakilanurun + ',' + prodid, 7 * 24); // 1 week
            bakilanarray.push(prodid);
        }
        if (bakilanarray.length >= 4 && shwbak == 1) {
            Vivense.cookie.set("showroomconversion2", 1, 7 * 24); // 1 week
            Vivense.cookie.delete("skubak");
            Vivense.cookie.delete("shwbak");
        } else {
            Vivense.cookie.delete("showroomconversion2");
        }
    }

    // Lead Generation - Büyük Mobilya Tracker
    if (window.product.vivense_category === "Büyük Mobilya"){

        var scenario = window.scenarios["3bm4s"];

        if (Vivense.cookie.exist(scenario.cookie)){
            var cookie = Vivense.cookie.get(scenario.cookie);

            if (cookie.split(',').indexOf(prodid) === -1){
                Vivense.cookie.set(scenario.cookie, cookie + ',' + prodid, 15 * 24);
            }
        } else {
            Vivense.cookie.set(scenario.cookie, prodid, 15 * 24);
        }
    }

    // Lead Generation - 500 TL altı Demonte ve Living
    if ( (window.product.vivense_category === "Demonte Mobilya" || window.product.vivense_category === "Living") && window.product.price < 500){

        var scenario = window.scenarios["3dl_500p_4s"];

        if (Vivense.cookie.exist(scenario.cookie)){
            var cookie = Vivense.cookie.get(scenario.cookie);

            if (cookie.split(',').indexOf(prodid) === -1){
                Vivense.cookie.set(scenario.cookie, cookie + ',' + prodid, 15 * 24);
            }
        } else {
            Vivense.cookie.set(scenario.cookie, prodid, 15 * 24);
        }
    }

});